import angular from 'angular';

angular
  .module('ladProvider')

  .factory('LadProviderService', [
    '$resource',
    'API_CONFIG',
    function($resource, API_CONFIG) {
      var LadProvider = $resource(
        API_CONFIG.url + '/v1/lad-provider/bo/:ladproviderId',
        { ladproviderId: '@id' },
        {
          // Recherche tous les providers LAD
          findAll: {
            url: API_CONFIG.url + '/v1/lad-provider',
            method: 'GET',
            isArray: true
          },
          // Liste de tous les donneurs d'ordres suivant des critères
          findByStatus: {
            method: 'GET',
            url: API_CONFIG.url + '/v1/lad-provider/findByStatus/:status',
            isArray: true
          },
          save: {
            method: 'POST',
            url: API_CONFIG.url + '/v1/lad-provider/bo',
            isArray: false
          }
        }
      );

      return LadProvider;
    }
  ]);
